var __awaiter = (this && this.__awaiter) || function (thisArg, _arguments, P, generator) {
    function adopt(value) { return value instanceof P ? value : new P(function (resolve) { resolve(value); }); }
    return new (P || (P = Promise))(function (resolve, reject) {
        function fulfilled(value) { try { step(generator.next(value)); } catch (e) { reject(e); } }
        function rejected(value) { try { step(generator["throw"](value)); } catch (e) { reject(e); } }
        function step(result) { result.done ? resolve(result.value) : adopt(result.value).then(fulfilled, rejected); }
        step((generator = generator.apply(thisArg, _arguments || [])).next());
    });
};
import { jsx as _jsx } from "nativewind/jsx-runtime";
import React from 'react';
import { useQuery } from '@tanstack/react-query';
import { ScreenLayout } from '@/components/ScreenLayout';
import { color } from '@/constant/color';
import { LogParamsProvider } from '@/logging/LogParamsProvider';
import useAppComponents from '@/hooks/useAppComponents';
import { usePlaceDetailScreenName } from '@/hooks/useFeatureFlags';
import ToiletReviewView from '../PlaceReviewFormScreen/views/ToiletReviewView';
export default function ToiletReviewFormScreen({ route, navigation, }) {
    var _a;
    const { api } = useAppComponents();
    const pdpScreen = usePlaceDetailScreenName();
    const placeId = (_a = route.params) === null || _a === void 0 ? void 0 : _a.placeId;
    const { data } = useQuery({
        queryKey: ['PlaceDetailV2', placeId],
        queryFn: () => __awaiter(this, void 0, void 0, function* () {
            var _a;
            const result = yield api.getPlaceWithBuildingPost({
                placeId: placeId !== null && placeId !== void 0 ? placeId : '',
            });
            return {
                place: result.data.place,
                building: result.data.building,
                isAccessibilityRegistrable: result.data.isAccessibilityRegistrable,
                accessibilityScore: (_a = result.data.accessibilityInfo) === null || _a === void 0 ? void 0 : _a.accessibilityScore,
            };
        }),
    });
    function gotoPlaceDetail() {
        var _a;
        if (navigation.canGoBack()) {
            navigation.goBack();
            return;
        }
        navigation.replace(pdpScreen, {
            placeInfo: {
                placeId: (_a = data === null || data === void 0 ? void 0 : data.place) === null || _a === void 0 ? void 0 : _a.id,
            },
        });
    }
    return (_jsx(LogParamsProvider, { params: { placeId }, children: _jsx(ScreenLayout, { isHeaderVisible: true, style: { backgroundColor: color.white }, children: _jsx(ToiletReviewView, { place: data === null || data === void 0 ? void 0 : data.place, gotoPlaceDetail: gotoPlaceDetail }) }) }));
}
